import * as Types from '../../types.generated';

import { api } from '../../rootApi';
export type ArtistListQueryVariables = Types.Exact<{
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
  page: Types.Scalars['Int'];
  searchQuery?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type ArtistListQuery = {
  __typename?: 'Query';
  artistList: {
    __typename?: 'ArtistList';
    paging: {
      __typename?: 'Paging';
      currentPage: number;
      totalItems: number;
      totalPages: number;
    };
    data?:
      | Array<{
          __typename?: 'Artist';
          id: number;
          firstName: string;
          lastName?: string | null | undefined;
          musicInstrument?:
            | { __typename?: 'MusicalInstrument'; id: number; name: string }
            | null
            | undefined;
          profilePicture?:
            | {
                __typename?: 'Attachment';
                filename: string;
                id: number;
                url: string;
              }
            | null
            | undefined;
        }>
      | null
      | undefined;
  };
};

export type InstrumentListQueryVariables = Types.Exact<{
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
  page: Types.Scalars['Int'];
  searchQuery?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type InstrumentListQuery = {
  __typename?: 'Query';
  instrumentList: {
    __typename?: 'MusicalInstrumentList';
    paging: {
      __typename?: 'Paging';
      currentPage: number;
      totalItems: number;
      totalPages: number;
    };
    data?:
      | Array<{
          __typename?: 'MusicalInstrument';
          id: number;
          name: string;
          profilePicture?:
            | {
                __typename?: 'Attachment';
                filename: string;
                id: number;
                url: string;
              }
            | null
            | undefined;
        }>
      | null
      | undefined;
  };
};

export type RagaListQueryVariables = Types.Exact<{
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
  page: Types.Scalars['Int'];
  searchQuery?: Types.InputMaybe<Types.Scalars['String']>;
  timeSectionIds?: Types.InputMaybe<
    Array<Types.Scalars['Int']> | Types.Scalars['Int']
  >;
}>;

export type RagaListQuery = {
  __typename?: 'Query';
  ragaList: {
    __typename?: 'RagaList';
    paging: {
      __typename?: 'Paging';
      currentPage: number;
      totalItems: number;
      totalPages: number;
    };
    data?:
      | Array<{
          __typename?: 'Raga';
          id: number;
          title: string;
          notes?: string | null | undefined;
          timeSections?:
            | Array<{
                __typename?: 'TimeSection';
                id: number;
                gradientTopColour: string;
                gradientBottomColour: string;
                name: string;
              }>
            | null
            | undefined;
          aarohaSwars?:
            | Array<{
                __typename?: 'RagaSwar';
                position: number;
                swar: { __typename?: 'Constant'; id: number; name: string };
              }>
            | null
            | undefined;
          avarohaSwars?:
            | Array<{
                __typename?: 'RagaSwar';
                position: number;
                swar: { __typename?: 'Constant'; id: number; name: string };
              }>
            | null
            | undefined;
          jaati?:
            | { __typename?: 'Constant'; id: number; name: string }
            | null
            | undefined;
          pakadSwars?:
            | Array<{
                __typename?: 'RagaSwar';
                position: number;
                swar: { __typename?: 'Constant'; id: number; name: string };
              }>
            | null
            | undefined;
          samvadiSwar?:
            | { __typename?: 'Constant'; id: number; name: string }
            | null
            | undefined;
          thaat?:
            | { __typename?: 'Constant'; id: number; name: string }
            | null
            | undefined;
          vaadiSwar?:
            | { __typename?: 'Constant'; id: number; name: string }
            | null
            | undefined;
        }>
      | null
      | undefined;
  };
};

export type ArtistQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  page: Types.Scalars['Int'];
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type ArtistQuery = {
  __typename?: 'Query';
  artist: {
    __typename?: 'Artist';
    id: number;
    firstName: string;
    lastName?: string | null | undefined;
    bio?: string | null | undefined;
    performances?: string | null | undefined;
    awards?: string | null | undefined;
    knowledgeCredits?: string | null | undefined;
    profilePicture?:
      | { __typename?: 'Attachment'; id: number; url: string }
      | null
      | undefined;
    musicInstrument?:
      | {
          __typename?: 'MusicalInstrument';
          name: string;
          profilePicture?:
            | { __typename?: 'Attachment'; url: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    playlist?:
      | {
          __typename?: 'PlaylistBase';
          id: number;
          totalDuration?: number | null | undefined;
          playlistSongs?:
            | {
                __typename?: 'PlaylistSongList';
                data?:
                  | Array<{
                      __typename?: 'PlaylistSong';
                      id: number;
                      position?: number | null | undefined;
                      song?:
                        | {
                            __typename?: 'BaseSongType';
                            id: number;
                            title: string;
                            trackLength: number;
                            isFavourited: boolean;
                            lowQuality?:
                              | {
                                  __typename?: 'Attachment';
                                  url: string;
                                  id: number;
                                }
                              | null
                              | undefined;
                            mediumQuality?:
                              | {
                                  __typename?: 'Attachment';
                                  url: string;
                                  id: number;
                                }
                              | null
                              | undefined;
                            highQuality?:
                              | {
                                  __typename?: 'Attachment';
                                  url: string;
                                  id: number;
                                }
                              | null
                              | undefined;
                            raga: {
                              __typename?: 'Raga';
                              id: number;
                              title: string;
                              timeSections?:
                                | Array<{
                                    __typename?: 'TimeSection';
                                    name: string;
                                    gradientTopColour: string;
                                    gradientBottomColour: string;
                                  }>
                                | null
                                | undefined;
                            };
                            artists: {
                              __typename?: 'ArtistsConnection';
                              edges?:
                                | Array<
                                    | {
                                        __typename?: 'ArtistsEdge';
                                        node?:
                                          | {
                                              __typename?: 'Artist';
                                              id: number;
                                              firstName: string;
                                              lastName?:
                                                | string
                                                | null
                                                | undefined;
                                              bio?: string | null | undefined;
                                              musicInstrument?:
                                                | {
                                                    __typename?: 'MusicalInstrument';
                                                    name: string;
                                                  }
                                                | null
                                                | undefined;
                                              profilePicture?:
                                                | {
                                                    __typename?: 'Attachment';
                                                    filename: string;
                                                    url: string;
                                                  }
                                                | null
                                                | undefined;
                                            }
                                          | null
                                          | undefined;
                                      }
                                    | null
                                    | undefined
                                  >
                                | null
                                | undefined;
                            };
                          }
                        | null
                        | undefined;
                    }>
                  | null
                  | undefined;
                paging: {
                  __typename?: 'Paging';
                  currentPage: number;
                  totalItems: number;
                  totalPages: number;
                };
              }
            | null
            | undefined;
        }
      | null
      | undefined;
  };
};

export type InstrumentQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  page: Types.Scalars['Int'];
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type InstrumentQuery = {
  __typename?: 'Query';
  instrument: {
    __typename?: 'MusicalInstrument';
    id: number;
    name: string;
    profilePicture?:
      | { __typename?: 'Attachment'; id: number; url: string }
      | null
      | undefined;
    playlist?:
      | {
          __typename?: 'PlaylistBase';
          id: number;
          totalDuration?: number | null | undefined;
          playlistSongs?:
            | {
                __typename?: 'PlaylistSongList';
                data?:
                  | Array<{
                      __typename?: 'PlaylistSong';
                      id: number;
                      position?: number | null | undefined;
                      song?:
                        | {
                            __typename?: 'BaseSongType';
                            id: number;
                            title: string;
                            trackLength: number;
                            isFavourited: boolean;
                            lowQuality?:
                              | {
                                  __typename?: 'Attachment';
                                  url: string;
                                  id: number;
                                }
                              | null
                              | undefined;
                            mediumQuality?:
                              | {
                                  __typename?: 'Attachment';
                                  url: string;
                                  id: number;
                                }
                              | null
                              | undefined;
                            highQuality?:
                              | {
                                  __typename?: 'Attachment';
                                  url: string;
                                  id: number;
                                }
                              | null
                              | undefined;
                            raga: {
                              __typename?: 'Raga';
                              id: number;
                              title: string;
                              timeSections?:
                                | Array<{
                                    __typename?: 'TimeSection';
                                    name: string;
                                    gradientTopColour: string;
                                    gradientBottomColour: string;
                                  }>
                                | null
                                | undefined;
                            };
                            artists: {
                              __typename?: 'ArtistsConnection';
                              edges?:
                                | Array<
                                    | {
                                        __typename?: 'ArtistsEdge';
                                        node?:
                                          | {
                                              __typename?: 'Artist';
                                              id: number;
                                              firstName: string;
                                              lastName?:
                                                | string
                                                | null
                                                | undefined;
                                              bio?: string | null | undefined;
                                              musicInstrument?:
                                                | {
                                                    __typename?: 'MusicalInstrument';
                                                    name: string;
                                                  }
                                                | null
                                                | undefined;
                                              profilePicture?:
                                                | {
                                                    __typename?: 'Attachment';
                                                    filename: string;
                                                    url: string;
                                                  }
                                                | null
                                                | undefined;
                                            }
                                          | null
                                          | undefined;
                                      }
                                    | null
                                    | undefined
                                  >
                                | null
                                | undefined;
                            };
                          }
                        | null
                        | undefined;
                    }>
                  | null
                  | undefined;
                paging: {
                  __typename?: 'Paging';
                  currentPage: number;
                  totalItems: number;
                  totalPages: number;
                };
              }
            | null
            | undefined;
        }
      | null
      | undefined;
  };
};

export type RagaQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  page: Types.Scalars['Int'];
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type RagaQuery = {
  __typename?: 'Query';
  raga?:
    | {
        __typename?: 'Raga';
        id: number;
        title: string;
        notes?: string | null | undefined;
        samvadiSwar?:
          | { __typename?: 'Constant'; id: number; name: string }
          | null
          | undefined;
        pakadSwars?:
          | Array<{
              __typename?: 'RagaSwar';
              position: number;
              swar: { __typename?: 'Constant'; id: number; name: string };
            }>
          | null
          | undefined;
        jaati?:
          | { __typename?: 'Constant'; id: number; name: string }
          | null
          | undefined;
        thaat?:
          | { __typename?: 'Constant'; id: number; name: string }
          | null
          | undefined;
        aarohaSwars?:
          | Array<{
              __typename?: 'RagaSwar';
              position: number;
              swar: { __typename?: 'Constant'; id: number; name: string };
            }>
          | null
          | undefined;
        avarohaSwars?:
          | Array<{
              __typename?: 'RagaSwar';
              position: number;
              swar: { __typename?: 'Constant'; id: number; name: string };
            }>
          | null
          | undefined;
        vaadiSwar?:
          | { __typename?: 'Constant'; id: number; name: string }
          | null
          | undefined;
        timeSections?:
          | Array<{
              __typename?: 'TimeSection';
              name: string;
              gradientTopColour: string;
              gradientBottomColour: string;
              profilePicture?:
                | { __typename?: 'Attachment'; id: number; url: string }
                | null
                | undefined;
            }>
          | null
          | undefined;
        playlist?:
          | {
              __typename?: 'PlaylistBase';
              id: number;
              totalDuration?: number | null | undefined;
              playlistSongs?:
                | {
                    __typename?: 'PlaylistSongList';
                    data?:
                      | Array<{
                          __typename?: 'PlaylistSong';
                          id: number;
                          position?: number | null | undefined;
                          song?:
                            | {
                                __typename?: 'BaseSongType';
                                id: number;
                                title: string;
                                trackLength: number;
                                isFavourited: boolean;
                                lowQuality?:
                                  | {
                                      __typename?: 'Attachment';
                                      url: string;
                                      id: number;
                                    }
                                  | null
                                  | undefined;
                                mediumQuality?:
                                  | {
                                      __typename?: 'Attachment';
                                      url: string;
                                      id: number;
                                    }
                                  | null
                                  | undefined;
                                highQuality?:
                                  | {
                                      __typename?: 'Attachment';
                                      url: string;
                                      id: number;
                                    }
                                  | null
                                  | undefined;
                                raga: {
                                  __typename?: 'Raga';
                                  id: number;
                                  title: string;
                                  notes?: string | null | undefined;
                                  samvadiSwar?:
                                    | {
                                        __typename?: 'Constant';
                                        id: number;
                                        name: string;
                                      }
                                    | null
                                    | undefined;
                                  pakadSwars?:
                                    | Array<{
                                        __typename?: 'RagaSwar';
                                        position: number;
                                        swar: {
                                          __typename?: 'Constant';
                                          id: number;
                                          name: string;
                                        };
                                      }>
                                    | null
                                    | undefined;
                                  jaati?:
                                    | {
                                        __typename?: 'Constant';
                                        id: number;
                                        name: string;
                                      }
                                    | null
                                    | undefined;
                                  thaat?:
                                    | {
                                        __typename?: 'Constant';
                                        id: number;
                                        name: string;
                                      }
                                    | null
                                    | undefined;
                                  aarohaSwars?:
                                    | Array<{
                                        __typename?: 'RagaSwar';
                                        position: number;
                                        swar: {
                                          __typename?: 'Constant';
                                          name: string;
                                        };
                                      }>
                                    | null
                                    | undefined;
                                  vaadiSwar?:
                                    | {
                                        __typename?: 'Constant';
                                        id: number;
                                        name: string;
                                      }
                                    | null
                                    | undefined;
                                };
                                artists: {
                                  __typename?: 'ArtistsConnection';
                                  edges?:
                                    | Array<
                                        | {
                                            __typename?: 'ArtistsEdge';
                                            node?:
                                              | {
                                                  __typename?: 'Artist';
                                                  id: number;
                                                  firstName: string;
                                                  lastName?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  bio?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  musicInstrument?:
                                                    | {
                                                        __typename?: 'MusicalInstrument';
                                                        name: string;
                                                      }
                                                    | null
                                                    | undefined;
                                                  profilePicture?:
                                                    | {
                                                        __typename?: 'Attachment';
                                                        filename: string;
                                                        url: string;
                                                      }
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined
                                      >
                                    | null
                                    | undefined;
                                };
                              }
                            | null
                            | undefined;
                        }>
                      | null
                      | undefined;
                    paging: {
                      __typename?: 'Paging';
                      currentPage: number;
                      totalItems: number;
                      totalPages: number;
                    };
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export const ArtistListDocument = `
    query artistList($perPage: Int, $page: Int!, $searchQuery: String) {
  artistList(perPage: $perPage, page: $page, searchQuery: $searchQuery) {
    paging {
      currentPage
      totalItems
      totalPages
    }
    data {
      id
      firstName
      lastName
      musicInstrument {
        id
        name
      }
      profilePicture {
        filename
        id
        url
      }
    }
  }
}
    `;
export const InstrumentListDocument = `
    query instrumentList($perPage: Int, $page: Int!, $searchQuery: String) {
  instrumentList(perPage: $perPage, page: $page, searchQuery: $searchQuery) {
    paging {
      currentPage
      totalItems
      totalPages
    }
    data {
      id
      name
      profilePicture {
        filename
        id
        url
      }
    }
  }
}
    `;
export const RagaListDocument = `
    query ragaList($perPage: Int, $page: Int!, $searchQuery: String, $timeSectionIds: [Int!]) {
  ragaList(
    perPage: $perPage
    page: $page
    searchQuery: $searchQuery
    timeSectionIds: $timeSectionIds
  ) {
    paging {
      currentPage
      totalItems
      totalPages
    }
    data {
      timeSections {
        id
        gradientTopColour
        gradientBottomColour
        name
      }
      id
      title
      aarohaSwars {
        position
        swar {
          id
          name
        }
      }
      avarohaSwars {
        position
        swar {
          id
          name
        }
      }
      jaati {
        id
        name
      }
      notes
      pakadSwars {
        position
        swar {
          id
          name
        }
      }
      samvadiSwar {
        id
        name
      }
      thaat {
        id
        name
      }
      vaadiSwar {
        id
        name
      }
    }
  }
}
    `;
export const ArtistDocument = `
    query artist($id: Int!, $page: Int!, $perPage: Int) {
  artist(id: $id) {
    id
    firstName
    lastName
    bio
    performances
    awards
    knowledgeCredits
    profilePicture {
      id
      url
    }
    musicInstrument {
      name
      profilePicture {
        url
      }
    }
    playlist {
      id
      totalDuration
      playlistSongs(page: $page, perPage: $perPage) {
        data {
          id
          position
          song {
            id
            title
            trackLength
            isFavourited
            lowQuality {
              url
              id
            }
            mediumQuality {
              url
              id
            }
            highQuality {
              url
              id
            }
            raga {
              id
              title
              timeSections {
                name
                gradientTopColour
                gradientBottomColour
              }
            }
            artists {
              edges {
                node {
                  id
                  firstName
                  lastName
                  bio
                  musicInstrument {
                    name
                  }
                  profilePicture {
                    filename
                    url
                  }
                }
              }
            }
          }
        }
        paging {
          currentPage
          totalItems
          totalPages
        }
      }
    }
  }
}
    `;
export const InstrumentDocument = `
    query instrument($id: Int!, $page: Int!, $perPage: Int) {
  instrument(id: $id) {
    id
    name
    profilePicture {
      id
      url
    }
    playlist {
      id
      totalDuration
      playlistSongs(page: $page, perPage: $perPage) {
        data {
          id
          position
          song {
            id
            title
            trackLength
            isFavourited
            lowQuality {
              url
              id
            }
            mediumQuality {
              url
              id
            }
            highQuality {
              url
              id
            }
            raga {
              id
              title
              timeSections {
                name
                gradientTopColour
                gradientBottomColour
              }
            }
            artists {
              edges {
                node {
                  id
                  firstName
                  lastName
                  bio
                  musicInstrument {
                    name
                  }
                  profilePicture {
                    filename
                    url
                  }
                }
              }
            }
          }
        }
        paging {
          currentPage
          totalItems
          totalPages
        }
      }
    }
  }
}
    `;
export const RagaDocument = `
    query raga($id: Int!, $page: Int!, $perPage: Int) {
  raga(id: $id) {
    id
    title
    samvadiSwar {
      id
      name
    }
    pakadSwars {
      swar {
        id
        name
      }
      position
    }
    jaati {
      id
      name
    }
    thaat {
      id
      name
    }
    notes
    aarohaSwars {
      position
      swar {
        id
        name
      }
    }
    avarohaSwars {
      position
      swar {
        id
        name
      }
    }
    vaadiSwar {
      id
      name
    }
    timeSections {
      name
      gradientTopColour
      gradientBottomColour
      profilePicture {
        id
        url
      }
    }
    playlist {
      id
      totalDuration
      playlistSongs(page: $page, perPage: $perPage) {
        data {
          id
          position
          song {
            id
            title
            trackLength
            isFavourited
            lowQuality {
              url
              id
            }
            mediumQuality {
              url
              id
            }
            highQuality {
              url
              id
            }
            raga {
              id
              title
              samvadiSwar {
                id
                name
              }
              pakadSwars {
                swar {
                  id
                  name
                }
                position
              }
              jaati {
                id
                name
              }
              thaat {
                id
                name
              }
              notes
              aarohaSwars {
                swar {
                  name
                }
                position
              }
              vaadiSwar {
                id
                name
              }
            }
            artists {
              edges {
                node {
                  id
                  firstName
                  lastName
                  bio
                  musicInstrument {
                    name
                  }
                  profilePicture {
                    filename
                    url
                  }
                }
              }
            }
          }
        }
        paging {
          currentPage
          totalItems
          totalPages
        }
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    artistList: build.query<ArtistListQuery, ArtistListQueryVariables>({
      query: (variables) => ({ document: ArtistListDocument, variables }),
    }),
    instrumentList: build.query<
      InstrumentListQuery,
      InstrumentListQueryVariables
    >({
      query: (variables) => ({ document: InstrumentListDocument, variables }),
    }),
    ragaList: build.query<RagaListQuery, RagaListQueryVariables>({
      query: (variables) => ({ document: RagaListDocument, variables }),
    }),
    artist: build.query<ArtistQuery, ArtistQueryVariables>({
      query: (variables) => ({ document: ArtistDocument, variables }),
    }),
    instrument: build.query<InstrumentQuery, InstrumentQueryVariables>({
      query: (variables) => ({ document: InstrumentDocument, variables }),
    }),
    raga: build.query<RagaQuery, RagaQueryVariables>({
      query: (variables) => ({ document: RagaDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useArtistListQuery,
  useLazyArtistListQuery,
  useInstrumentListQuery,
  useLazyInstrumentListQuery,
  useRagaListQuery,
  useLazyRagaListQuery,
  useArtistQuery,
  useLazyArtistQuery,
  useInstrumentQuery,
  useLazyInstrumentQuery,
  useRagaQuery,
  useLazyRagaQuery,
} = injectedRtkApi;
